import { assets } from "@/lib/assets"
import {Gift, Heart, Leaf, Plane} from 'lucide-react'

const specs = [
  { label: "容量", value: "10 ml" },
  { label: "產地", value: "台灣" },
  { label: "保存期限", value: "3 年" },
]

const promises = [
  { icon: Leaf, title: "溫和配方" },
  { icon: Gift, title: "精緻包裝" },
  { icon: Plane, title: "台灣出貨" },
  { icon: Heart, title: "限量收藏" },
]

function ProductDetail() {
  return (
    <section id="product" data-nav="dark" className="bg-[#f7f3ea] px-8 py-20 md:px-10 md:py-28">
      <div className="mx-auto grid max-w-5xl items-start gap-4 md:grid-cols-2 md:items-center md:gap-12">
        <div className="overflow-hidden bg-[#d7e0e8]">
          <img
            src={assets.bottleMobile}
            alt="微光 Inner Light 香氛噴霧"
            className="h-full w-full object-cover md:hidden"
          />
          <img
            src={assets.bottle}
            alt="微光 Inner Light 香氛噴霧"
            className="hidden h-full w-full object-cover md:block"
          />
        </div>

        <div className="-mt-1 md:mt-0">
          <div className="flex items-end gap-3">
            <h2 className="font-serif-tc text-4xl tracking-[0.16em] text-slate-800">微光</h2>
            <span className="mb-1 font-display text-lg italic text-slate-500">Inner Light</span>
          </div>
          <p className="mt-4 font-serif-tc text-[15px] leading-8 tracking-[0.08em] text-slate-600">
            把這一點光，
            <br />
            帶回日常。
          </p>
          <p className="mt-6 font-display text-[28px] text-slate-700">NT$ 1,680</p>

          <a
            href="#order"
            className="mt-8 inline-flex h-10 w-full items-center justify-center bg-[#2b4456] text-[12px] tracking-[0.28em] text-white transition hover:bg-[#1d3342]"
          >
            立即訂購
          </a>

          <div className="mt-8 max-w-sm space-y-6 border-t border-slate-200 pt-6 text-[13px] leading-7 text-slate-500">
            <p>
              明亮的柑橘揭開香氣，
              <br />
              橙花與玫瑰溫柔綻放，
              <br />
              最後落入木質與大地的沉靜。
            </p>
            <p>
              有些傷，不必急著遺忘，
              <br />
              多些勇氣，會帶你走向微光
            </p>
            <p>
              微光，是在黑暗之後，
              <br />
              依然願意相信，前方有光。
            </p>
          </div>

          <div className="mt-6 space-y-2">
            {specs.map((spec) => (
              <div key={spec.label} className="grid grid-cols-[72px_1fr] text-[13px] text-slate-600">
                <span className="text-slate-400">{spec.label}</span>
                <span>{spec.value}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-4 gap-3 text-center">
            {promises.map((item) => (
              <div key={item.title} className="flex flex-col items-center gap-2 text-slate-500">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-300">
                  <item.icon size={16} />
                </span>
                <span className="text-[11px] tracking-[0.08em]">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductDetail
